var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};



//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/ecf67698/0/pomelo/oceopin/web/app/themes/oceopin/node_modules/core-js/modules/_shared.js
// module id = 50
// module chunks = 0